var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsericon = function SvgUsericon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM10.762 9a3.001 3.001 0 0 1 2.69 1.66l1.44 2.89a1 1 0 0 1-.89 1.45H2a1 1 0 0 1-.89-1.45l1.44-2.89A3 3 0 0 1 5.24 9h5.522Z"
  })));
};
export default SvgUsericon;